import factory from '@atlassian/trello-error-ext';
export const AttachmentTypeRestrictedError = factory(
  'Attachment::TypeRestricted',
);
